import React from 'react'
import { PropTypes } from 'prop-types'
import { PILLARS_TEXT, PILLAR_COLOURS, RESOURCEdb } from '@wellbeingxltd/fe-lib/constants'
import LogoChooser from 'components/common/LogoChooser'
import './style.scss'

const { SLEEP, NUTRITION, EXERCISE, COMMUNITY, STRESS, OCCUPATION } = RESOURCEdb.PILLARS

const BUTTONS = [
    { colour: PILLAR_COLOURS[SLEEP].dark, title: SLEEP },
    { colour: PILLAR_COLOURS[NUTRITION].dark, title: NUTRITION },
    { colour: PILLAR_COLOURS[EXERCISE].dark, title: EXERCISE },
    { colour: PILLAR_COLOURS[COMMUNITY].dark, title: COMMUNITY },
    { colour: PILLAR_COLOURS[STRESS].dark, title: STRESS },
    { colour: PILLAR_COLOURS[OCCUPATION].dark, title: OCCUPATION },
]

export const PillarButton = ({ answer, onSelect, pillarSelected }) => {
    const { colour, title } = BUTTONS.filter(button => button.title === answer.text)[0]
    return (
        <button
            className="pillarMenuButton"
            onClick={() => onSelect(answer)}
            style={{
                outlineColor: colour,
                background:
                    pillarSelected && PILLARS_TEXT[title].split(' ').join('').includes(pillarSelected) ? PILLAR_COLOURS[pillarSelected].light : '',
            }}
        >
            <span className="pillarMenuButtonIconAndText">
                <LogoChooser label={`${title}Illustration`} width={32} />
                <span className="pillarMenuButtonLabel">{PILLARS_TEXT[title]}</span>
            </span>
        </button>
    )
}

PillarButton.propTypes = {
    pillar: PropTypes.object,
}
